type ConfigInputType = "checkbox" | "select_one" | "select_many" | "string" | "number" | "array";

export type ConfigTemplateInputProperty = {
  type: ConfigInputType;
  required: boolean;
  options?: string[];
  items?: ConfigTemplateArrayItem;
};

export type ConfigTemplateArrayItem = {
  type: "object" | "string";
  properties?: Record<string, { required: boolean }>;
};

export type ConfigTemplateInputsFamily<T extends string = string> = T;

export type ConfigTemplateInputs<T extends string> = Record<
  ConfigTemplateInputsFamily<T>,
  ConfigTemplateInputProperty
>;

export enum ConfigTemplateType {
  Filters = "filters",
  Order = "order"
}
